import {Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ModalService} from "../../services/modal.service";
import { properties } from 'src/environments/properties';

declare let $: any;

@Component({
    selector: 'app-notification-modal',
    templateUrl: './notification-modal.component.html',
})
export class NotificationModalComponent implements OnInit {

    KEYCODE_TAB: number = 9;

    @Input() errorMsg: string;
    @Input() campaignTitle: string;
    properties = properties;

    constructor(private bsModalRef: BsModalRef,
                private bsModalService: BsModalService,
                private modalService: ModalService,
                private hostElement: ElementRef) {
    }

    ngOnInit(): void {
        this.bsModalService.onShown.subscribe((e) => {
            this.modalService.setMobileFocusLoop(this.hostElement.nativeElement);
        });
        this.bsModalService.onHidden.subscribe(() => {
            this.modalService.removeMobileFocusLoop();
        })
    }

    close() {
        this.bsModalRef.hide();
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
        if (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB) {
            let focusableEls = this.hostElement.nativeElement;
            let modalContent = $(focusableEls).find('a[href], [href], input, select, textarea, button, [tabindex]:not([tabindex="-1"]), a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
            let firstFocusableEl = modalContent.first()[0];
            let lastFocusableEl = modalContent.last()[0];

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        }
    }

}
